import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { useSessionStore } from "../models/store/useSessionStore";

import { clearCampaignDashboardState } from "@/entities/campaign/model/lib/campaignDashboardStorage";
import { useCampaignFilterStore } from "@/entities/campaign/model/store/useCampaignFilterStore";
import { useCampaignFormStore } from "@/entities/campaign/model/store/useCampaignFormStore";
import { SS_DATEFILTER_NAMES } from "@/entities/localstorage/model/const/localstorage_names";
import { clearAuthSession } from "@/entities/localstorage/model/lib/authSessionStorage";
import { setAccessToken } from "@/shared/config/orval/makeRequest";
import { clearSessionDateRange } from "@/shared/lib/dateFilter/sessionDateRange";

export const useLogoutQuery = (options: { redirectToLogin?: boolean } = {}) => {
    const { redirectToLogin = true } = options;
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const clear = useSessionStore((state) => state.clear);
    const { flush } = useCampaignFormStore();
    const resetDashboardFilters = useCampaignFilterStore((state) => state.resetDashboardFilters);

    const onFetched = () => {
        clearCampaignDashboardState();
        clearAuthSession();
        localStorage.removeItem("refreshToken");
        setAccessToken("");
        clearSessionDateRange(SS_DATEFILTER_NAMES.campaign);
        flush();
        resetDashboardFilters();
        clear();
        queryClient.clear();
        if (redirectToLogin) navigate("/login", { replace: true });
    };

    return useMutation({
        mutationKey: ["logout"],
        mutationFn: async () => {},
        retry: 0,
        networkMode: "always",
        gcTime: Infinity,
        onSuccess: onFetched,
        onError: onFetched,
    });
};
